import AbstractConfig from "../../../core/config/AbstractConfig";

export default class PersonalReportConfig extends AbstractConfig {
    setImageData(key, data) {
        this._data.imageData[key] = data;
    }

    getImageData(key) {
        return this._data.imageData[key];
    }

    /**
     * Clears the image data for a specific image ID.
     * Use this to free up memory space when an image no longer needs to be stored (such as in-game snapshots after they have been included into the PDF).
     * @param {string} key 
     */
    clearImageData(key) {
        delete this._data.imageData[key];
    }

    getFonts() {
        return this._data.fonts;
    }

    get pageWidth() {
        return this.getValue('settings.pageWidth');
    }

    get pageHeight() {
        return this.getValue('settings.pageHeight');
    }

    get pageMarginH() {
        return this.getValue('settings.pageMarginH');
    }

    get pageMarginV() {
        return this.getValue('settings.pageMarginV');
    }

    get footerY() {
        return this.getValue('settings.footerY');
    }
}